const brand = sessionStorage.getItem('brand');
export const shared = {
  bpDropDown: {
    placeholders: {
      search: 'Sök'
    }
  },
  bpTable: {
    loadMore: 'Ladda mer',
    view: 'Visa',
  },
  countryDropDown: {
    placeholders: {
      searchCountry: 'Sök land'
    }
  },
  createNew: {
    continue: 'Fortsätt',
  },
  datePicker: {
    chooseADate: 'Välj ett datum',
  },
  dateRangePicker: {
    choosePeriod: 'Välj period',
    today: 'Idag',
    lastWeek: 'Förra veckan',
    lastMonth: 'Förra månaden'
  },
  demoBotModal: {
    pleaseProvideNumberForTesting: 'Vänligen ange det nummer du vill använda för testning',
    resendOtp: 'Skicka OTP igen',
    enterOtp: 'Ange OTP',
    verifyOtp: 'Verifiera OTP',
    sendOtp: 'Skicka OTP',
    cancel: 'Avbryt',
    placeholders: {
      phone: 'Telefon*',
      enterOtp: 'Ange OTP*',
    }
  },
  feedback: {
    pleaseSelectYourReason: 'Vänligen välj din anledning',
    cancel: 'Avbryt',
    submit: 'Skicka!',
    giveFeedback: 'Ge feedback',
    ratings: 'Betyg',
    reasonBehindYourDecision: 'Anledningen bakom ditt beslut',
    shareYourExperience: 'Dela din erfarenhet',
    reason1: 'anledning1',
    reason2: 'anledning2'
  },
  feedbackModal: {
    paymentIsInProgress: 'Betalningen pågår',
    pleaseDoNotCloseThisWindow: 'Var god stäng inte detta fönster',
    placeholders: {
      name: 'Namn',
      email: 'E-post*',
      phone: 'Telefon*',
      pleaseShareYourUseCase: 'Vänligen dela med dig av ditt användningsfall'
    }
  },
  layout: {
    sidebar: {
      notifications: 'Aviseringar',
      myAccount: 'Mitt konto',
      logout: 'Logga ut',
      goOnline: 'Gå online',
      manage: 'Hantera',
      deactivate: 'Inaktivera',
      activate: 'Aktivera',
      delete: 'Ta bort',
      home: 'Hem',
      bots: 'Bots',
      inbox: 'Inkorg',
      analytics: 'Analytik',
      team: 'Team',
      subscriptions: 'Prenumerationer',
      more: 'Mer',
      users: 'Användare',
      partnerTeam: 'Partner Team',
      createNewBot: 'Skapa ny bot',
      dashboard: 'Instrumentpanel',
      customers: 'Kunder',
      partnerPanel: 'Partner Panel',
      raiseATicket: 'Höj en biljett',
      plans: 'Planer',
      activities: 'Aktiviteter',
      feedbacks: 'Feedback',
      emailActivity: 'E-postaktivitet',
      configurations: 'Konfigurationer',
      copy: 'Kopiera',
      developer: 'Utvecklare',
      yourFriendWillMissYou: 'Din vän kommer att sakna dig',
      rateYourBotCreationExperience: 'Betygsätt din botskapande erfarenhet',
      whatMadeYouDeleteYourBot: 'Vad fick dig att ta bort din bot?',
      iCreatedByMistake: 'Jag skapade av misstag',
      iWantToCreateAnotherBot: 'Jag vill skapa en annan bot',
      couldNotFindFeaturesThatINeeded: 'Kunde inte hitta funktioner jag behövde',
      uiWasHardToNavigate: 'UI var svårt att navigera',
      iDonotWantToTell: 'Jag vill inte berätta',
      other: 'Annat',
      weWillDoOurBestToMakeAutomationFun: 'Vi kommer att göra vårt bästa för att göra automation roligt och enkelt för alla.',
      appTooltip: {
        TOOLTIP_GO_ONLINE: 'Växla för att tillåta eller blockera live-chattförfrågningar',
        TOOLTIP_NOTIFICATION: 'Alla aviseringar',
        TOOLTIP_MY_ACCOUNT: 'Din profil och lösenordsäkerhet',
        TOOLTIP_LOGOUT: 'Logga ut från instrumentpanelen'
      },
      modal: {
        logout: 'Logga ut',
        botDeleteFeedbackForm: 'Bot Delete Feedback Form',
        areYouSureToLogOut: 'Är du säker på att du vill logga ut?',
        yesIWillBeBack: 'Ja! Jag kommer tillbaka',
        deleteBot: 'Ta bort bot',
        areYouSureToDeleteBot: 'Är du säker på att du vill ta bort den här boten?',
        cancel: 'Avbryt',
        saveAndDelete: 'Spara och ta bort'
      }
    }
  },
  modal: {
    cancel: 'Avbryt',
    yesDelete: 'Ja, ta bort!'
  },
  notify: {
    youHave: 'Du har ',
    new: ' nya '
  },
  profileIcon: {
    appTooltip: {
      weSuggestUsingYourCompanyLogo: 'Vi föreslår att du väljer din företagslogotyp. Lägg till en PNG- eller JPG-fyrkantig bild under 1 MB.'
    }
  },
  upgradeModal: {
    upgradeToKingPlan: 'Hoppsan! Babyplanen erbjuder ENDAST EN GRATIS bot. Var god uppgradera till King-planen för att skapa fler bots.',
    noIAmGood: 'Nej, jag är nöjd',
    iWantToUpgrade: 'Jag vill uppgradera',
    oops: 'Hoppsan! ',
    planOfferOnlyOneFreeBot: ' erbjuder ENDAST EN GRATIS bot. Var god uppgradera till ',
    planToCreateMoreBots: ' för att skapa fler bots.'
  },
  webPreview: {
    preview: ' Förhandsgranska',
    botsMessages: `Bots meddelanden`,
    bot: 'Bot ',
    eleven36AM: ' 11:36 AM',
    usersReply: `Användares svar`,
    landingPageBot: 'Landningssida Bot',
    chatbot: 'Chattbot',
    chat: 'Chatt',
    placeholders: {
      typeYourAnswer: 'Skriv ditt svar'
    }
  },
  paymentLink: {
    discardPayment: 'Förkasta betalning',
    completePayment: 'Slutför betalning',
    importantUpdate: 'Viktig uppdatering',
    accountUpdate: 'Kontouppdatering',
    youHave: 'Du har',
    exceededTheMessagesLimit: 'överskridit meddelandegränsen',
    ofYour: 'av din',
    planAnd: 'plan och',
    botsAreNoLongerActive: 'bots är inte längre aktiva',
    onYourWebsite: 'på din webbplats.',
    youHaveEitherIncompletePaymentOn: 'Du har antingen ofullständig betalning på',
    orYouHaveNotSuccessfullyUpgradedYourPlan: 'eller så har du inte uppgraderat din plan framgångsrikt.',
    orYouHaveNotSuccessfullyWhiteLabeledYourBot: 'eller så har du inte framgångsrikt vitetiketterat din bot.',
    orYouHaveNotSuccessfullyPurchasedTheMessagesAddOn: 'eller så har du inte framgångsrikt köpt "messages Add-on".',
    incompletePaymentMessage: 'Du har antingen ofullständig betalning på eller så har du inte uppgraderat din plan framgångsrikt.',
    please: 'Vänligen',
    complete: 'Slutför',
    upgrade: 'Uppgradera',
    services: 'tjänster',
    yourPlanToContinueServices: 'din plan för att fortsätta tjänster',
    yourPaymentToContinue: 'din betalning för att fortsätta',
    forAnyQueryPleaseWriteUs: 'För eventuella frågor skriv till oss på',
    close: 'Stäng',
    writeOn: '',
    upgradePlan: 'Uppgraderingsplan',
    discardModal: {
      title: 'Förkasta betalning',
      description: 'Är du säker på att du vill förkasta din betalning?',
      confirmText: 'Ja, förkasta betalning'
    },
    maintenanceHeading: 'Kommande schemalagd underhållsmeddelande:',
    maintenanceNotice: 'BotPenguins tjänster kommer att vara tillfälligt otillgängliga på grund av underhåll den 28/11/2023 från 19:00 till 19:30 IST. Vi beklagar besväret. Vi kommer snart tillbaka. Tack för att du förstår.'
  },
  bpExport: {
    exportStatus: 'Exportstatus',
    tasksExport: 'Uppgifter - Exportera',
    download: 'Ladda ner',
    inProgress: 'pågår',
  },
  singleSession: {
    close: 'Stäng',
    useHere: 'Använd här',
    openInAnotherWindow: `${brand} är öppen i ett annat fönster/flik. Klicka på "Använd här" för att använda ${brand} i den här fliken.`
  }
};
